import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-submit-btn',
    templateUrl: './submit-btn.component.html',
    styleUrls: ['./submit-btn.component.scss'],
    animations: [
        trigger('wobble', [
            transition('inactive => active', animate(1000, keyframes([
                style({ transform: 'translate3d(0, 0, 0)', offset: 0 }),
                style({ transform: 'translate3d(-2px, 0, 0)', offset: 0.1 }),
                style({ transform: 'translate3d(2px, 0, 0)', offset: 0.2 }),
                style({ transform: 'translate3d(-2px, 0, 0)', offset: 0.3 }),
                style({ transform: 'translate3d(2px, 0, 0)', offset: 0.35 }),
                style({ transform: 'translate3d(0px, 0, 0)', offset: 0.4 }),
                style({ transform: 'none', offset: 1 }),
            ]))),
        ]), // trigger
    ],
    imports: [NgIf],
    standalone: true
})
export class SubmitBtnComponent implements OnInit, OnChanges {
  @Input() btnCopy = 'Submit';
  @Input() hasError;
  @Input() loading;
  @Input() disabled = false;
  @Input() inputClasses = '';
  @Output() click = new EventEmitter;

  public wobbleState = 'inactive';

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change: SimpleChanges) {
    if (change.hasError && change.hasError.currentValue) {
      this.wobbleState = 'active';
    }
  }

  resetAnimation() {
    this.wobbleState = 'inactive';
  }

  clicked(evt) {
    evt.stopPropagation();
    this.click.emit(evt);
  }
}
